import {createSelector} from 'reselect';
import {AppState} from '../../index';

export const skipassClientInfoSelector = () =>
  createSelector(
    (state: AppState) => ({
      clientInfo: state.skipass.clientInfo,
      isLoading: state.skipass.isLoading,
    }),
    (data) => data,
  );
